import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import Dashboard from './pages/Dashboard'
import './_style.scss'
import './i18n'

ReactDOM.render(
  <Dashboard />,
  document.getElementById('root')
)

document.title = process.env.REACT_APP_TITLE
reportWebVitals()
